import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    RESPOND_LIST_PASSPORTS,
    RESPOND_ADD_PASSPORT,
    RESPOND_UPDATE_PASSPORT,
    RESPOND_UPDATE_PASSPORT_WITH_OAUTH,
    RESPOND_REMOVE_PASSPORT,
    NOTIFY_PASSPORT_UPDATE,
    RESPOND_LIST_STORY,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/integration/sapMsgDefinitions";
import {
    SAPPassport,
    SAPPassportHeader,
    SAPPassportID,
    SAPStory,
} from "userful-chronos-app-common-js/dist/models/integration/sap";
import integrationStore from "../integrationStore";
import { sapActions } from "../sapSlice";
import { registerErrorMsgHandlerByMsgDefinition } from "userful-chronos-app-common-js/dist/message/messageRegistery";

registerMsgHandler(RESPOND_LIST_PASSPORTS, (payload) => {
    console.debug("receive SAP_RESPOND_LIST_PASSPORTS");
    const data = JSON.parse(payload) as SAPPassport[];
    integrationStore.dispatch(sapActions.setPassports(data));
});

registerMsgHandler(RESPOND_ADD_PASSPORT, (payload) => {
    console.debug("receive SAP_RESPOND_ADD_PASSPORT");
    const data = JSON.parse(payload) as SAPPassportHeader;
    integrationStore.dispatch(sapActions.changeLoadState("RENDER"));
    integrationStore.dispatch(sapActions.setOpenForm(false));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_ADD_PASSPORT, (data) => {
    integrationStore.dispatch(sapActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_UPDATE_PASSPORT, (payload) => {
    console.debug("receive RESPOND_UPDATE_PASSPORT");
    const data = JSON.parse(payload) as SAPPassportHeader;
    integrationStore.dispatch(sapActions.changeLoadState("RENDER"));
    integrationStore.dispatch(sapActions.setOpenForm(false));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_UPDATE_PASSPORT, (data) => {
    integrationStore.dispatch(sapActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_UPDATE_PASSPORT_WITH_OAUTH, (payload) => {
    console.debug("receive RESPOND_UPDATE_PASSPORT_WITH_OAUTH");
    const data = JSON.parse(payload) as SAPPassportHeader;
    integrationStore.dispatch(sapActions.changeLoadState("RENDER"));
    integrationStore.dispatch(sapActions.setOpenForm(false));
});

registerErrorMsgHandlerByMsgDefinition(RESPOND_UPDATE_PASSPORT_WITH_OAUTH, (data) => {
    integrationStore.dispatch(sapActions.changeLoadState("RENDER"));
});

registerMsgHandler(RESPOND_REMOVE_PASSPORT, (payload) => {
    console.debug("receive RESPOND_REMOVE_PASSPORT");
    const data = JSON.parse(payload) as SAPPassportID;
    integrationStore.dispatch(sapActions.removePassport(data));
});

registerMsgHandler(NOTIFY_PASSPORT_UPDATE, (payload) => {
    console.debug("receive NOTIFY_PASSPORT_UPDATE");
    const data = JSON.parse(payload) as SAPPassport;
    integrationStore.dispatch(sapActions.addOrUpdatePassport(data));
});

registerMsgHandler(RESPOND_LIST_STORY, (payload) => {
    console.debug("receive RESPOND_LIST_STORY");
    const data = JSON.parse(payload) as SAPStory[];
    integrationStore.dispatch(sapActions.setListStory(data));
});
